"use strict";
var ModalWindowController = (function () {
    /* @ngInject */
    function ModalWindowController(userSessionService, preferenceService, $rootScope) {
        var _this = this;
        this.userSessionService = userSessionService;
        this.preferenceService = preferenceService;
        this.$rootScope = $rootScope;
        this.currentPage = 1;
        this.visibleContent = 0;
        this.preferenceServiceResponse = function (status) {
            if (status >= 400) {
                _this.$rootScope.loadingError = true;
            }
        };
        this.showModal = this.userSessionService.showWelcomeModal();
    }
    ModalWindowController.prototype.isFinalSlide = function () { return this.visibleContent === 4; };
    ModalWindowController.prototype.isContentVisible = function (content) { return content === this.visibleContent; };
    ModalWindowController.prototype.nextContent = function () {
        if (this.visibleContent !== 4) {
            this.visibleContent++;
        }
        else {
            this.closeThisModal();
        }
    };
    ModalWindowController.prototype.prevContent = function () { this.visibleContent--; };
    ModalWindowController.prototype.closeThisModal = function () {
        this.showModal = false;
        this.userSessionService.setHideWelcomeModal();
        if (this.neverShow) {
            this.preferenceService.setUserPreference({ testprepWelcomeModal: false })
                .then(this.preferenceServiceResponse);
        }
    };
    return ModalWindowController;
}());
exports.ModalWindowController = ModalWindowController;



/** WEBPACK FOOTER **
 ** ./app/common/modal-window/modal-window.controller.ts
 **/